import { entitlements } from 'utils/entitlements';
import { names } from 'utils/names';

function shuffleAndSelectRND(array): String[] {
  let currentIndex: number = array.length;
  let randomIndex: number;

  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }

  return array.slice(0, 5);
}

const getSampleData = () => {
  const givenName = shuffleAndSelectRND(names)[0].replace(' ', '_');
  const surname = shuffleAndSelectRND(names)[0].replace(' ', '_');
  const email = givenName + '.' + surname + '@devUser.de';
  const sampleData = {
    email: email.replace(' ', '_'),
    givenName: givenName.replace(' ', '_'),
    surname: surname.replace(' ', '_'),
    initials: givenName.charAt(0) + surname.charAt(0),
    title: 'Lord',
    dev: 'true',
    schacGender: 1,
    eduPersonAffiliation: ['student', 'member'],
    eduPersonEntitlement: shuffleAndSelectRND(entitlements),
    schacUserStatus: 'active',
    schacPersonalUniqueCode: Math.floor(Math.random() * (999999 - 1) + 1),
    relationship: [
      {
        hsroEduPersonStudiengangKurz: 'BI',
        hsroEduPersonStudiengangLang: 'Bachelor Bauingenieurwesen',
        hsroEduPersonFakultaetKurz: 'HTB',
        hsroEduPersonFakultaetLang: 'Fakultät für Holztechnik und Bau',
        dfnEduPersonFinalDegree: '84',
        hsroEduPersonLepsem: 4,
        hsroEduPersonPlaceOfStudy: 'RO',
        ou: 'HTB',
        main_relationship: 1
      },
      {
        hsroEduPersonStudiengangKurz: 'HA',
        hsroEduPersonStudiengangLang: 'Bachelor Holzbau und Ausbau',
        hsroEduPersonFakultaetKurz: 'HTB',
        hsroEduPersonFakultaetLang: 'Fakultät für Holztechnik und Bau',
        dfnEduPersonFinalDegree: '84',
        hsroEduPersonLepsem: 7,
        hsroEduPersonPlaceOfStudy: 'RO',
        ou: 'HTB',
        main_relationship: 0
      }
    ]
  };
  return sampleData;
};

export default getSampleData;
